<template>
    <transition>
        <div v-show="$store.getters.forgetFlow.show" class="forget" @click.self="close">
            <div class="forget-container">
                <p class="form-header">
                    <i class="iconfont icon-cancel" @click="close"></i>
                </p>
                <email-form v-if="$store.getters.forgetFlow.type === 'email'"></email-form>
                <phone-form v-else-if="$store.getters.forgetFlow.type === 'mobile'"
                    @updateInfo="updateInfo"></phone-form>
                <passwd-form v-else></passwd-form>
            </div>
        </div>
    </transition>
</template>

<script>
import emailForm from './Forget/Email'
import phoneForm from './Forget/Mobile'
import passwdForm from './Forget/Password'
export default {
    name: 'forget',
    components: {
        emailForm,
        phoneForm,
        passwdForm
    },
    data() {
        return {
            /* 缓存子组件mobile的数据 */
            account: '',  //手机号
            code: '',     //区号
            token: '',
            encryption_code: ''
        }
    },
    methods: {
        close() {
            //清空表单状态
            this.$children.forEach(item => {
                item.resetFields();
            })
            this.$store.dispatch('updateForgetFlow', {
                show: false,
                type: this.$store.getters.forgetFlow.type
            })
        },
        updateInfo(code, account, enCode, token) {
            this.account = account;
            this.code = code;
            this.encryption_code = enCode;
            this.token = token;
        }
    }
}
</script>

<style lang="scss">
.forget-container {
    width: 600px;
    height: 450px;
    border-radius: 4px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.19), 0px 8px 17px rgba(0, 0, 0, 0.2);
    color: #484848;
    background-color: #fff;
    
    .forget-title {
        font-size: 24px;
        margin: 16px 0;
    }
    .forget-subtitle {
        font-size: 14px;
        color: #767676;
        margin-bottom: 50px;
    }
    .form-header {
        text-align: right;
        box-sizing: border-box;
        padding: 10px 22px;
        i {
            cursor: pointer;
        }
    }
}
.forget-container-inner {
    text-align: center;
    box-sizing: border-box;
    padding: 0 140px;
}
.form-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(90deg, #52D6CE 0%, #00A9BA 100%);
    border-radius: 45px;
    margin: 52px 0;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
}
</style>


<style lang="scss" scoped>
.forget {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(55, 55, 55, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/views/Public/Forget.vue